import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import SpotlightFrame, { type SpotlightInjectedProps, type SpotlightLayoutProps } from './SpotlightFrame';

const SpotlightQuoteContent: React.FC<SpotlightInjectedProps & { content: any }> = ({ content, tokens, isStory }) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'relative',
          maxWidth: 307,
          padding: isStory ? '34px 0 27px 22px' : '28px 0 21px 18px',
          borderLeft: `${isStory ? 8 : 6}px solid ${t.accent}`,
          color: t.ink,
          fontSize: typeSize(isStory ? 30 : 24),
          fontWeight: 900,
          letterSpacing: '-0.8px',
          lineHeight: 1.28
        }}
      >
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: isStory ? -6 : -4,
            left: isStory ? 10 : 8,
            color: t.accent,
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontSize: typeSize(isStory ? 64 : 52),
            fontWeight: 700,
            lineHeight: 1,
            opacity: 0.55,
            pointerEvents: 'none'
          }}
        >
          {'\u201C'}
        </span>
        {content.quote}
      </div>
      {content.author ? (
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            marginTop: isStory ? 27 : 20,
            padding: isStory ? '8px 12px' : '6px 10px',
            color: t.onAccent,
            background: t.accent,
            fontSize: typeSize(isStory ? 10.5 : 8.8),
            fontWeight: 900,
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            transform: 'rotate(-1deg)'
          }}
        >
          <span>—</span>
          {content.author}
        </div>
      ) : null}
    </div>
  );
};

const SpotlightQuoteLayout: React.FC<SpotlightLayoutProps> = props => (
  <SpotlightFrame {...props}>
    <SpotlightQuoteContent content={props.content || {}} />
  </SpotlightFrame>
);

export default SpotlightQuoteLayout;
